export default "__VITE_ASSET__5255efce__"